import { Theme } from 'styled-components';
import { IThemeValueGetter } from '../types';

export const transition =
  (size: keyof Theme['transitions'] = 'base'): IThemeValueGetter =>
  ({ theme }) =>
    theme.transitions[size] || theme.transitions.base;
